(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('SearchbarController', SearchbarController);

    SearchbarController.$inject = ['$rootScope', '$scope', '$state', '$window', 'Auth', 'Principal', 'ProfileService', 'LoginService', '$log'];

    function SearchbarController ($rootScope, $scope, $state, $window, Auth, Principal, ProfileService, LoginService, $log) {
        var vm = this;
        vm.logout = logout;
        var v2AuthBaseUrl = '';

        ProfileService.getProfileInfo().then(function(response) {
            v2AuthBaseUrl = response.v2AuthBaseUrl || '';
        });

        $scope.isAuthenticated = Principal.isAuthenticated;
        $scope.account = null;
        getUser();


        vm.globalSearch = function() {
            if (typeof(vm.searchPhrase) === "string" && vm.searchPhrase.length > 0) {
                gtag('event', "global_search", {searchPhrase: vm.searchPhrase});

                $state.go("home-search", {'phrase':vm.searchPhrase});
            }
        };

        $rootScope.$on('authenticationSuccess', function() {
           getUser();
        });

        function getUser() {
            Principal.identity().then(function(account) {
                $scope.account = account;
            });
        }

        function logout() {
            Auth.logout().then(function() {
                $window.location.href = v2AuthBaseUrl + '/v2/auth/login';
            }).catch(function(error) {
                $log.warn('Logout failed:', error);
                $window.location.href = v2AuthBaseUrl + '/v2/auth/login';
            });
        }
    }
})();
